import axios from 'axios';
import { store } from '../store'
import { LOGIN_PATH } from '../constants'
import history from '../history'


class Api {
  constructor() {
    if(store.getState().app_token) axios.defaults.headers.common['Authorization'] = `Bearer ${store.getState().app_token.accessToken}`;

    // Number of pending per Api instance
    this.numberOfAjaxCAllPending = 0
    this.cancelCurrentRequest = null

    //Response Interceptor
    axios.interceptors.response.use(response => {
      this.numberOfAjaxCAllPending = Math.abs(this.numberOfAjaxCAllPending-1)

      return response;
    }, function(error) {
      if(error.response && error.response.status === 401){
        history.push(LOGIN_PATH);
      }
      return Promise.reject(error);
    });

  }

  login(url, token) {
    return axios.get(url)
  }

  logout(url, params) {
    return axios.post(url, params)
  }

  createNewPlan(url, params){
    return axios.post(url, params)
  }

  updatePlan(url, params){
    return axios.put(url, params)
  }

  toggleRisk(url, params){
    return axios.put(url, params)
  }

  get = (url, params, config = {}) => {
    this.numberOfAjaxCAllPending++
    return axios.get(url, { ...params, ...config })
  }

  post(url, params, config = {}) {
    return axios.post(url, params, config)
  }

  put(url, params, config = {}) {
    return axios.put(url, params, config)
  }

  delete(url, params, config = {}) {
    return axios.delete(url, { ...params, ...config })
  }

  cancelPendingRequest = () => {
    if(this.numberOfAjaxCAllPending > 0 && this.cancelCurrentRequest){
      this.cancelCurrentRequest()
    }
  }

  giveCancelToken = () => {
    const CancelToken = axios.CancelToken;
    return new CancelToken(e => this.cancelCurrentRequest = e)
  }

}

export default Api;



// WEBPACK FOOTER //
// ./src/services/api.js